import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import TextLabel from "components/Common/TextLabel/TextLabel";
import ShippingReportByRITM from "components/ShippingReportByRITM/ShippingReportByRITM";
import React, { useEffect, useState } from "react";
import { useAuth } from "context/AuthContext";

export default function ShippingReportAccess() {
  const { ticketNumber } = useParams();
  const [access, setAccess] = useState(false);
  const { hasAnyPermission, isLoaded } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;
    const permitted = hasAnyPermission([
      "PII_Group_FULL",
      "PII_Group_Med"
    ]);
    if (!permitted) {
      localStorage.setItem("failedUrl", window.location.pathname);

      window.location.href = "/";
      return;
    }
    setAccess(permitted);
  }, [hasAnyPermission, isLoaded]);

  return (
    <>
      {access ? (
        <ShippingReportByRITM ticketNumber={ticketNumber} />
      ) : (
        <Box sx={{ padding: 1 }}>
          <TextLabel text={"Not authorized to view this report."} />
        </Box>
      )}
    </>
  );
}
